import PropTypes from 'prop-types';
import ReloadHelper from '../../utils/ReloadHelper';
import Translations from '../../utils/Translations';
import { generateKey } from '../../utils/CommonUtils';
import { Component } from 'react';

class GlobalSearchDropdownRow extends Component {
	constructor(props) {
		super(props);

		this.onClickShowAll = this.onClickShowAll.bind(this);

		// sub-components
		this.getSpecialRow = this.getSpecialRow.bind(this);
		this.getDefaultRow = this.getDefaultRow.bind(this);
	}

	onClickShowAll(e) {
		this.props.onElementClick();
		ReloadHelper.reload(this.props.allLink, e);
	}

	getSpecialRow() {
		const items = [];

		for (let i = 0; i < this.props.items.length; i++) {
			const onClick = (e) => {
				this.props.onElementClick();
				ReloadHelper.reload(this.props.items[i].link, e);
			};

			const style = { backgroundImage: 'url(' + this.props.items[i].imageUrl + ')' };

			if (this.props.items[i].imageAspect !== 1) {
				style.backgroundSize = '200%';
			}

			let name = '';

			const tmp = this.props.items[i].name.toLowerCase();
			const pos = tmp.indexOf(this.props.searchPattern.toLowerCase());

			if (pos > -1) {
				const p1 = this.props.items[i].name.substr(0, pos);
				const p2 = this.props.items[i].name.substr(pos, this.props.searchPattern.length);
				const p3 = this.props.items[i].name.substr(pos + this.props.searchPattern.length);

				name = (
					<span className={'global_search-dropdown-actor-name'}>
						{p1}
						<span className={'global_search-dropdown-actor-name-hit'}>{p2}</span>
						{p3}
					</span>
				);
			} else {
				name = <span className={'global_search-dropdown-actor-name'}>{this.props.items[i].name}</span>;
			}

			items.push(
				<button key={generateKey('global_search-actor', items.length)} onClick={onClick} className={'global_search-dropdown-actor'}>
					<span
						style={style}
						className={
							'global_search-dropdown-actor-image' +
							(this.props.items[i].online ? ' -online' : '') +
							(this.props.items[i].mobileVideoCall ? ' -mobile-videocall' : '')
						}
					/>
					<div className={'global_search-dropdown-actor-info-container'}>
						{name}
						<span className={'global_search-dropdown-actor-online' + (this.props.items[i].online ? ' -online' : '')}>
							{this.props.items[i].online ? 'Online' : 'Offline'}
						</span>
					</div>
				</button>,
			);
		}

		return (
			<div onClick={this.onClickShowAll} className={'global_search-dropdown-row -special'}>
				<div className={'global_search-dropdown-special'}>
					<span className={'global_search-dropdown-row-dummy'} />
					<span className={'global_search-dropdown-row-title'}>{this.props.title}</span>
					<span className={'global_search-dropdown-row-count'}>{this.getCount()}</span>
				</div>
				<div className={'global_search-dropdown-special -flex'}>
					<span>{items}</span>
					<span>
						<span className={'global_search-dropdown-row-dummy'} />
						<button onClick={this.onClickShowAll} className={'global_search-dropdown-row-button -special'}>
							{Translations.get('ShowAll')} &raquo;
						</button>
					</span>
				</div>
			</div>
		);
	}

	getDefaultRow() {
		return (
			<span onClick={this.onClickShowAll} className={'global_search-dropdown-row'}>
				<span onClick={this.onClickShowAll} className={'global_search-dropdown-clickable'}>
					<span className={'global_search-dropdown-row-dummy'} />
					<span className={'global_search-dropdown-row-title'}>{this.props.title}</span>
					<span className={'global_search-dropdown-row-count'}>{this.getCount()}</span>
				</span>
				<button onClick={this.onClickShowAll} className={'global_search-dropdown-row-button'}>
					{Translations.get('ShowAll')} &raquo;
				</button>
			</span>
		);
	}

	getCount() {
		if (this.props.count > 9999) {
			return '9999+';
		} else {
			return this.props.count;
		}
	}

	render() {
		if (this.props.items.length > 0) {
			return this.getSpecialRow();
		} else {
			return this.getDefaultRow();
		}
	}
}

GlobalSearchDropdownRow.propTypes = {
	title: PropTypes.string,
	count: PropTypes.number,
	allLink: PropTypes.string,
	items: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			imageUrl: PropTypes.string,
			imageAspect: PropTypes.number,
			link: PropTypes.string,
			online: PropTypes.bool,
			mobileVideoCall: PropTypes.bool,
		}),
	),
	onElementClick: PropTypes.func,
	searchPattern: PropTypes.string,
};

export default GlobalSearchDropdownRow;
